const FLICKITY_ARROW_ICON = "M93.856 49.68c0 1.31-1.037 2.374-2.315 2.374H14.735l19.87 20.388a2.4 2.4 0 0 1 .678 1.68 2.4 2.4 0 0 1-.677 1.678 2.274 2.274 0 0 1-3.274 0L7.823 51.68a2.418 2.418 0 0 1 0-3.358L31.332 24.2a2.274 2.274 0 0 1 3.274 0 2.418 2.418 0 0 1 0 3.358L15.36 47.304h76.18c1.28 0 2.316 1.064 2.316 2.375z";

export default FLICKITY_ARROW_ICON;
